import {
  GET_LOCATION_LIST,
  GET_LOCATION_LIST_FAILED,
  GET_LOCATION_LIST_SUCCESS,

  EXPORT_LOCATION_LIST,
  EXPORT_LOCATION_LIST_FAILED,
  EXPORT_LOCATION_LIST_SUCCESS,

  DELETE_LOCATION,
  DELETE_LOCATION_FAILED,
  DELETE_LOCATION_SUCCESS,

  GET_ADVANCE_BOOKING_CHARTS,
  GET_ADVANCE_BOOKING_CHARTS_SUCCESS,
  GET_ADVANCE_BOOKING_CHARTS_FAILED,

  GET_STAY_NIGHTS_CHARTS,
  GET_STAY_NIGHTS_CHARTS_SUCCESS,
  GET_STAY_NIGHTS_CHARTS_FAILED,

  GET_BOOKING_STATUS_RATIO,
  GET_BOOKING_STATUS_RATIO_SUCCESS,
  GET_BOOKING_STATUS_RATIO_FAILED,

  GET_REVENUE_DISTRIBUTION_ACCOUNT_LEVELS,
  GET_REVENUE_DISTRIBUTION_ACCOUNT_LEVELS_SUCCESS,
  GET_REVENUE_DISTRIBUTION_ACCOUNT_LEVELS_FAILED,
} from './actionTypes';

export const actionGetLocationList = (payload) => ({
  payload,
  type: GET_LOCATION_LIST,
});

export const actionGetLocationListSuccess = (payload) => ({
  payload,
  type: GET_LOCATION_LIST_SUCCESS,
});

export const actionGetLocationListFailed = (payload) => ({
  payload,
  type: GET_LOCATION_LIST_FAILED,
});

export const actionExportLocationList = (payload) => ({
  payload,
  type: EXPORT_LOCATION_LIST,
});

export const actionExportLocationListSuccess = (payload) => ({
  payload,
  type: EXPORT_LOCATION_LIST_SUCCESS,
});

export const actionExportLocationListFailed = (payload) => ({
  payload,
  type: EXPORT_LOCATION_LIST_FAILED,
});

export const actionDeleteLocation = (payload) => ({
  payload,
  type: DELETE_LOCATION,
});

export const actionDeleteLocationSuccess = (payload) => ({
  payload,
  type: DELETE_LOCATION_SUCCESS,
});

export const actionDeleteLocationFailed = (payload) => ({
  payload,
  type: DELETE_LOCATION_FAILED,
});

export const actionGetAdvanceBookingCharts = (payload) => ({
  payload,
  type: GET_ADVANCE_BOOKING_CHARTS,
});

export const actionGetAdvanceBookingChartsSuccess = (payload) => ({
  payload,
  type: GET_ADVANCE_BOOKING_CHARTS_SUCCESS,
});

export const actionGetAdvanceBookingChartsFailed = (payload) => ({
  payload,
  type: GET_ADVANCE_BOOKING_CHARTS_FAILED,
});

export const actionGetStayNightsCharts = (payload) => ({
  payload,
  type: GET_STAY_NIGHTS_CHARTS,
});

export const actionGetStayNightsChartsSuccess = (payload) => ({
  payload,
  type: GET_STAY_NIGHTS_CHARTS_SUCCESS,
});

export const actionGetStayNightsChartsFailed = (payload) => ({
  payload,
  type: GET_STAY_NIGHTS_CHARTS_FAILED,
});

export const actionGetBookingStatusRatio = (payload) => ({
  payload,
  type: GET_BOOKING_STATUS_RATIO,
});

export const actionGetBookingStatusRatioSuccess = (payload) => ({
  payload,
  type: GET_BOOKING_STATUS_RATIO_SUCCESS,
});

export const actionGetBookingStatusRatioFailed = (payload) => ({
  payload,
  type: GET_BOOKING_STATUS_RATIO_FAILED,
});

export const actionGetRevenueDistributionAccountLevels = (payload) => ({
  payload,
  type: GET_REVENUE_DISTRIBUTION_ACCOUNT_LEVELS,
});

export const actionGetRevenueDistributionAccountLevelsSuccess = (payload) => ({
  payload,
  type: GET_REVENUE_DISTRIBUTION_ACCOUNT_LEVELS_SUCCESS,
});

export const actionGetRevenueDistributionAccountLevelsFailed = (payload) => ({
  payload,
  type: GET_REVENUE_DISTRIBUTION_ACCOUNT_LEVELS_FAILED,
});
